import { render, staticRenderFns } from "./ProcessMetricsTimeFilter.vue?vue&type=template&id=2b9ac897&scoped=true"
import script from "./ProcessMetricsTimeFilter.ts?vue&type=script&lang=ts&external"
export * from "./ProcessMetricsTimeFilter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ac897",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9ac897')) {
      api.createRecord('2b9ac897', component.options)
    } else {
      api.reload('2b9ac897', component.options)
    }
    module.hot.accept("./ProcessMetricsTimeFilter.vue?vue&type=template&id=2b9ac897&scoped=true", function () {
      api.rerender('2b9ac897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/ProcessesTableSection/ProcessMetricsTimeFilter/ProcessMetricsTimeFilter.vue"
export default component.exports